import { MousePointer2 } from 'lucide-react'

export default function ReplayMouseLayer({ mousePos, isClicking }) {
  if (!mousePos || mousePos.x == null) return null

  return (
    <div
      style={{
        position: 'absolute',
        left: `${mousePos.x * 100}%`,
        top: `${mousePos.y * 100}%`,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      <MousePointer2
        fill={isClicking ? '#ef4444' : 'black'}
        color="white"
        size={24}
        style={{
          filter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.3))',
          transform: isClicking ? 'scale(0.9)' : 'scale(1)',
          transition: 'transform 0.1s ease',
        }}
      />
      {isClicking && (
        <div style={{
          position: 'absolute',
          top: -10,
          left: -10,
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: '2px solid #ef4444',
          animation: 'ping 0.5s cubic-bezier(0, 0, 0.2, 1)'
        }} />
      )}
      <style>{`
        @keyframes ping {
          0% { transform: scale(1); opacity: 1; }
          100% { transform: scale(1.5); opacity: 0; }
        }
      `}</style>
    </div>
  )
}